import React from "react";
import heroimg from "../../Assets/homeimgs/homeimg2.png";
const HeroSection3 = () => {
  return (
    <React.Fragment>
      <div
        className="h-[60vh] md:h-[75vh] lg:h-[85vh] flex items-center justify-center"
        style={{
          backgroundImage: `url(${heroimg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right",
        }}
      >
        <div className="text-center text-white max-w-[90%] sm:max-w-[80%] md:max-w-[70%] space-y-4 md:space-y-6 lg:space-y-10 px-4">
          <h1
            style={{ fontFamily: "Poppins, sans-serif" }}
            className="text-xl sm:text-2xl md:text-4xl lg:text-6xl font-normal space-y-4"
          >
            <h1>Strong Foundations for Railway </h1> <h1>Bridges</h1>
          </h1>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl">
            OTL specializes in durable and secure railway bridge construction,
            ensuring precision and excellence for reliable infrastructure that
            stands the test of time.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeroSection3;
